import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=565d7152&scoped=true&"
import script from "./Teacher.vue?vue&type=script&lang=js&"
export * from "./Teacher.vue?vue&type=script&lang=js&"
import style1 from "./Teacher.vue?vue&type=style&index=1&id=565d7152&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565d7152",
  null
  
)

export default component.exports